import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { wsGetAll } from "services/WService";
import Modal from "components/Tvendo/Common/ModalBase";

export default function ModalFamily(props) {
  const family = props.model;

  const [dataChanging, setDataChanging] = useState(family);

  const [lines, setLines] = useState([]);

  async function listLines() {
    let response = await wsGetAll("logi/line");
    if (response.success) setLines(response.data);
  }

  function handleChange(field, value) {
    setDataChanging({
      ...dataChanging,
      [field]: value
    });
  }

  useEffect(() => {
    listLines();
  }, []);

  return (
    <Modal
      title="Familia"
      model={family}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      dataChanging={dataChanging}
      setDataChanging={setDataChanging}
      entity="logi/family"
      state
    >
      <TextField
        label="Código"
        fullWidth
        type="text"
        name="code"
        margin="normal"
        defaultValue={!!family ? family.code : ""}
        required
      />
      <TextField
        label="Descripción"
        fullWidth
        type="text"
        name="description"
        margin="normal"
        defaultValue={!!family ? family.description : ""}
        required
      />
      <Autocomplete
        options={lines}
        getOptionLabel={(option) => option.description}
        defaultValue={
          !!family
            ? lines.find((line) => line.id == family.logi_line_id)
            : undefined
        }
        renderInput={(params) => (
          <TextField {...params} label="Linea" margin="normal" required />
        )}
        onChange={(e, item) => {
          if (!!item) {
            return handleChange("logi_line_id", item.id);
          }
          handleChange("logi_line_id", null);
        }}
      />
    </Modal>
  );
}
